<template>
  <div class="info-search-container">
    <small-header title="信息查询"></small-header>
    <div class="info-search-main">
      <div v-for="(item, index) in menus" class="info-search-item">
        <div class="info-search-item-icon" :style="{backgroundImage: `url(${item.icon})`}"></div>
        <div class="info-search-item-icon-fill" :style="{backgroundImage: `url(${item.iconFill})`}"></div>
        <div class="info-search-item-text">{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        {
          title: '守重企业申报',
          icon: require('../../../../assets/img/icon_01_mr.png'),
          iconFill: require('../../../../assets/img/icon_01_xt.png')
        },
        {
          title: '守重企业公示',
          icon: require('../../../../assets/img/icon_02_mr.png'),
          iconFill: require('../../../../assets/img/icon_02_xt.png')
        },
        {
          title: '守重企业信息查询',
          icon: require('../../../../assets/img/icon_03_mr.png'),
          iconFill: require('../../../../assets/img/icon_03_xt.png')
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.info-search-container {
  width: 1200px;
  margin: 30px auto 0;
  background: #fff;
  .info-search-main {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info-search-item {
      width: 360px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #0077FE;
      border-radius: 4px;
      background: #F0F7FF;
      color: #1279EC;
      transition: all 300ms;
      cursor: pointer;
      .info-search-item-icon {
        width: 70px;
        height: 70px;
        background-size: cover;
        background-position: center center;
      }
      .info-search-item-icon-fill {
        display: none;
        width: 70px;
        height: 70px;
        background-size: cover;
        background-position: center center;
      }
      .info-search-item-text {
        font-size: 24px;
        font-weight: 500;
        margin-left: 10px;
      }
    }
    .info-search-item:hover {
      background: #0076FE;
      color: #fff;
      .info-search-item-icon {
        display: none;
      }
      .info-search-item-icon-fill {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/InfoSearch/index.vue